import React from 'react';
import { UnmountClosed } from 'react-collapse';
import { Hr } from 'Components/frameworks/hr/Hr';
import { Icon } from 'Components/frameworks/icon/Icon';
import { ICONS } from 'Components/utils/icon/icons';
type AdditionalTransportFilterProps = {
  isOpen?: boolean;
  title: string;
  children: React.ReactNode;
};
export const AdditionalTransportFilter = ({
  isOpen = true,
  title,
  children,
}: AdditionalTransportFilterProps) => {
  const [toggleFilter, setToggleFilter] = React.useState(isOpen);
  return (
    <div data-testid="AdditionalTransportFilter">
      <button
        data-testid="ToggleAdditionalTransportFilter"
        type="button"
        onClick={() => setToggleFilter(!toggleFilter)}
        className="flex w-full items-center justify-between"
      >
        <span className="text-20 font-semibold">{title}</span>
        <Icon name={ICONS.ARROW_TOP} rotation={toggleFilter ? 0 : 180} />
      </button>
      <UnmountClosed isOpened={toggleFilter}>
        <div className="pt-30">{children}</div>
      </UnmountClosed>
      <Hr className="my-20" />
    </div>
  );
};
